module.exports = __webpack_public_path__ + "img/9x16_border.cf6e8d27.jpg";